const SET_USERS = 'SET_USERS';
const SET_USERS_REFACTORED = 'SET_USERS_REFACTORED';
const SET_SELECTED_USER = 'SET_SELECTED_USER';

export { SET_USERS, SET_USERS_REFACTORED, SET_SELECTED_USER };
